/**
 * @title global.hbp.js: Wrapper module to combine global.base.js and utility1.js
 * This will be included only on Home, Browse & Product pages
 * HBP=Home, Browse & Product
 */

define(['utility1', 'globalBase'], function(util, Global) {
  if (typeof window.COSTCO == 'undefined') {
      window.COSTCO = {};
    }
    $(document).ready(function() {
      window.COSTCO.Global = Global;
      window.COSTCO.util = util;
      Global.init();
    });
    return Global;
});


// WEBPACK FOOTER //
// ./js/global/global.hbp.js